/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SbSharedTitle_itemSearch$ref = any;
export type SbSharedTitle_itemSearch = {
    readonly pageType: string | null;
    readonly meta: {
        readonly header: string | null;
    } | null;
    readonly " $refType": SbSharedTitle_itemSearch$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbSharedTitle_itemSearch",
    "type": "ItemSearchQueryConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "pageType",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "meta",
            "storageKey": null,
            "args": null,
            "concreteType": "MetaData",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "header",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = '41df8b708b5921a5f7394de2777ffb41';
export default node;
